import React from 'react';
import LoginForm from '../../components/organisms/auth/LoginForm';

const LoginPage = () => {
  return <LoginForm />;
};

export default LoginPage;
